import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./moderntradenew.scss";
import "../../../style.scss";

function ModernTradeSidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    return (
        <>
        <div class="msb" id="msb">
            <nav class="navbar navbar-default" role="navigation">
            {/* <!-- Brand and toggle get grouped for better mobile display --> */}
            {/* <div class="navbar-header">
                <div class="brand-wrapper">
                <div class="brand-name-wrapper">
                    <a class="navbar-brand" href="#">
                    SAITAMA
                      
                </div>
                </div>
            </div> */}

            {/* <!-- Main Menu --> */}
            <div class="side-menu-container">
                <ul class="nav navbar-nav">

                    <li 
                        onClick={() => navigate("/dashboard/modern-trade")}
                        style={{ cursor: "pointer" }}
                        className={path.includes('/modern-trade') ? 'active' : ''}>  <i class="fa fa-dashboard"></i> Dashboard  </li>
                    <li 
                        className={path.includes('/mt-upload-data') ? 'active' : ''}
                        onClick={() => navigate("/dashboard/mt-upload-data")}
                        style={{ cursor: "pointer" }}>
                             <i class="fa fa-puzzle-piece"></i> Upload Data  
                    </li>
                    <li 
                        className={path.includes('/mt-view-data') ? 'active' : ''}
                        onClick={() => navigate("/dashboard/mt-view-data")}
                        style={{ cursor: "pointer" }}>
                             <i class="fa fa-heart"></i> View Data  
                    </li>
                    <li className={path.includes('/extras') ? 'active' : ''}>  <span class="glyphicon glyphicon-signal"></span> Extras  </li>
                </ul>
            </div>
            {/* </div><!-- /.navbar-collapse --> */}
            </nav>  
        </div>
        </>
    )
}

export default ModernTradeSidebar;